module.exports = __webpack_public_path__ + "img/ad1.ec211617.png";